module.exports = __webpack_public_path__ + "static/tp-5014cc3482dadb26ba6b9626dc239857.jpg";